import { PriceVO } from '@zazume/zzm-utils';

interface DiscountedMonths {
  freeMonths?: number;
  concept?: string;
}

interface ConstructorParams {
  value?: number;
  absolutePrice?: PriceVO;
  type: ManagementFeeType;
  discount?: DiscountedMonths;
}

export class ManagementFee {
  value?: number;
  absolutePrice?: PriceVO;
  type: ManagementFeeType;
  discount?: DiscountedMonths;

  constructor(params: ConstructorParams) {
    this.value = params.value;
    this.absolutePrice = params.absolutePrice;
    this.type = params.type;
    this.discount = params.discount;
  }

  static fromRaw(commercialisationFee: any): ManagementFee {
    return new ManagementFee({
      value: commercialisationFee.value,
      absolutePrice: commercialisationFee.absolutePrice && PriceVO.fromPrimitive(commercialisationFee.absolutePrice),
      type: commercialisationFee.type,
      discount: commercialisationFee.discount
    });
  }
}

export const ManagementFeeTypes = <const>['absolute', 'percentage'];
export type ManagementFeeType = (typeof ManagementFeeTypes)[number];
